import moment from "moment"
import React, { useEffect, useRef, useState } from "react"
import { Button, Col, FormGroup, Input, InputGroup, InputGroupAddon, Label, Row } from "reactstrap"
import PageBody from "../../../components/PageBody"
import IconEdit from '../../../assets/images/icon-edit.png'
import Select, { components } from 'react-select'
import { useHistory } from "react-router"
import ModalPopup from "../../../components/ModalPopup"
import CustomerAdd from "../../customer/CustomerAdd"
import profilePic from '../../../assets/images/users/no-img.jpg';
import PriceUtils from "../../../helpers/PriceUtils"
import styled from "styled-components"
import { toast } from "react-toastify"
import { cloneDeep } from "lodash"
import APIClient from "../../../helpers/APIClient"
import { baseUrl } from "../../../constants/environment"
import NumberFormat from 'react-number-format';
import AsyncSelect from "react-select/async";
import { Link } from "react-router-dom"
import IconSearch from '../../../assets/images/icon-search.png';
import TextUtils from "../../../helpers/TextUtils"
import ProductUtil from "../../../helpers/ProductUtil"

const OrderAddInfo = (props: any) => {
    const { data, setData, type, onlyView, product, setProduct, productTemplate } = props
    const router = useHistory()
    const [modalIsOpen, setIsOpen] = useState(false);
    const [open, setOpen] = useState(false)
    const [query, setQuery] = useState('')
    const [queryProduct, setQueryProduct] = useState('')
    const [loadingDesignation, setLoadingProduct] = useState(false);

    const loadProduct = async () => {
        setLoadingProduct(true)
        let response: any = await APIClient.GET(`${baseUrl}/product`, {
            page: 1,
            limit: 20,
            name: queryProduct,
            include_product_stock: true,
        });
        setLoadingProduct(false)
        if (response.response?.data !== undefined) {
            const ListArr = ProductUtil.parseProduct(response?.response?.data)
            return ListArr
        } else {
            return []
        }
    };

    const handleInputChangeProduct = (newValue: any) => {
        setQueryProduct(newValue);
        return newValue;
    };

    const handleProductAdd = (item: any) => {

        setProduct([...product, item]);
    };

    const handleProductUpdate = (dataDetail: any, index: number) => {
        // check xem đã có sp kia trong danh sách chưa nha
        const checkIsset = product?.reduce((prev: any, item: any, indexCheck: number) => {
            if (indexCheck !== index && item?.product_id === dataDetail?.product_id && item?.variant_id === dataDetail?.variant_id) {
                if (dataDetail?.product?.type !== 'batch') {
                    prev = false
                } else if (dataDetail?.product?.type === 'batch' && item?.batch_id === dataDetail?.batch_id) {
                    prev = false
                }
            }
            return prev
        }, true)
        if (!checkIsset) {
            toast.warning('Sản phẩm đã được thêm')
            return
        }
        let newDetailtiveUser = cloneDeep(product);
        newDetailtiveUser[index] = dataDetail;
        setProduct(newDetailtiveUser);
    };

    const handleProductRemove = (index: number) => {
        let newDetailtiveUser = cloneDeep(product);
        newDetailtiveUser.splice(index, 1);
        setProduct(newDetailtiveUser);
    };

    const calTotal = () => {
        let total: any = {
            total: 0,
            discount: 0,
        }
        total = product?.reduce((prev: any, item: any) => {
            const totalItem = Number(item?.price || 0)
            const discount = item?.discount_type === 'price' ? Number(item?.discount_value || 0) :
                totalItem * Number(item?.discount_value || 0) / 100
            prev.total += totalItem * Number(item?.quantity || 0)
            prev.discount += discount * Number(item?.quantity || 0)
            return prev
        }, total)
        total.sub_total = Number(total?.total || 0) - Number(total?.discount || 0)
        return total
    }

    useEffect(() => {
        calTotal_discount_c();
    }, [product, data?.orderspackage?.type == 'account_card'])

    const calTotal_discount_c = () => {
        let total_group = 0;
        if(onlyView) {
            total_group = data?.total_group_package
        } else {
            total_group = Number(data?.orderspackage?.total_group || 0) - Number(data?.orderspackage?.total_group_used || 0) + Number(data?.total_package_used || 0);
        }
        let total_group_used = 0;
        
        product?.map((item: any, index: any) => {
            // giá gốc sản phẩm
            const price = Number(item?.price || 0) * Number(item?.quantity || 0);
            const discount = item?.discount_type === 'price' ? Number(item?.discount_value || 0) :
                price * Number(item?.discount_value || 0) / 100;
            // giá sp sau giảm giá trực tiếp
            const priceBefor = Number(price || 0) - (Number(discount || 0) * Number(item?.quantity || 0));
            // price sản phẩm được giảm của gói
            let discount_by_package_price = 0
            // Giá áp dụng giảm giá theo gói
            let price_apply_discount_by_package = 0
            let price_used = 0
            const productItem = product[index] || {};
            if(total_group == 0) {
                price_used = Number(item?.price) * Number(item?.quantity);
                if(productItem) {
                    product[index] = {
                        ...productItem,
                        priceDiscountC : price_used || 0,
                        discountC: discount_by_package_price || 0
                    }
                }
                return
            }
            if (data?.orderspackage?.product_type?.includes(item?.product?.product_type)) {
                if(total_group >= priceBefor) {
                    price_apply_discount_by_package = priceBefor
                }else{
                    price_apply_discount_by_package = total_group
                }
                discount_by_package_price = Math.floor(Number((price_apply_discount_by_package * data?.orderspackage?.discount_order / 100) || 0));
                price_used = priceBefor - discount_by_package_price
                total_group = total_group - price_used <= 0 ? 0 : total_group - price_used
                total_group_used = total_group_used + price_used
            }else {
                price_used = Number(price || 0) - (Number(discount || 0) * Number(item?.quantity || 0));
            }
            if(productItem) {
                product[index] = {
                    ...productItem,
                    priceDiscountC : price_used || 0,
                    discountC: discount_by_package_price || 0
                }
            }
        },0)
        return {total_group, total_group_used}
    }

    const total = calTotal()
    
    return (
        <PageBody>
            <div className="nutri-title mb-3">Sản phẩm</div>
            {!onlyView &&
                <div className="mb-2">
                    <Row>
                        <Col xl={8}>
                            <InputGroup>
                                <InputGroupAddon addonType="prepend" className='input-group-prepend-input'>
                                    <img src={IconSearch} width={18} height={18} alt="" />
                                </InputGroupAddon>
                                <AsyncSelect
                                    className="react-select react-select-search mb-2"
                                    classNamePrefix="react-select"
                                    onInputChange={handleInputChangeProduct}
                                    loadOptions={loadProduct}
                                    inputValue={queryProduct}
                                    placeholder={loadingDesignation ? "Đang tải dữ liệu..." : "Tìm kiếm tên/mã sản phẩm"}
                                    noOptionsMessage={() => queryProduct ? "Không tìm thấy dữ liệu" : 'Tìm kiếm tên/mã sản phẩm'}
                                    loadingMessage={() => 'Đang tìm kiếm...'}
                                    cacheOptions
                                    defaultOptions={productTemplate}
                                    onChange={(val: any) => {
                                        handleProductAdd({
                                            ...data,
                                            product_id: val?.product_id,
                                            variant_id: val?.variant_id || undefined,
                                            product: val,
                                            batch_id: '',
                                            unit_id: 0,
                                            quantity: 1,
                                            price: val?.price,
                                            discount_value: '',
                                            discount_type: 'price',
                                        })
                                    }}
                                    value={productTemplate?.filter(
                                        (option: any) => data?.product_id == option.product_id && data?.variant_id == option.variant_id
                                    )}
                                    isDisabled={onlyView}
                                    components={{
                                        Menu: (props: any) => (
                                            <components.Menu {...props} >
                                                {props.children}
                                                <Link to="/product/add" target="_blank" rel="noopener noreferrer" className='select-menu-add'>
                                                    <i className="uil-plus mr-1"></i> Tạo mới sản phẩm
                                                </Link>
                                            </components.Menu>
                                        )
                                    }}
                                    formatOptionLabel={(props: any) => {
                                        const { value, label, customAbbreviation, stock_quantity, variant_id, product_id, batch_id, avatar, price } = props
                                        const stock = stock_quantity && stock_quantity[variant_id || 'root']
                                            && stock_quantity[variant_id || 'root'][data?.branch_id || 'root']
                                            && stock_quantity[variant_id || 'root'][data?.branch_id || 'root'][batch_id || 'root'] || 0
                                        return (
                                            <div className="item-porduct-add">
                                                <div className="item-porduct-add-img tee-file-preview">
                                                    <img src={avatar || profilePic} style={{ maxWidth: 'unset', maxHeight: 'unset' }} />
                                                </div>
                                                <div className="item-porduct-add-info">
                                                    <div className="item-porduct-add-name">
                                                        <b>{label}</b>
                                                        <span>{PriceUtils.format(price)}</span>
                                                    </div>
                                                    <div className="item-porduct-add-sub-name">Tồn kho: {PriceUtils.format(stock, '')}</div>
                                                </div>
                                            </div>
                                        )
                                    }}
                                    styles={{
                                        ...customStyles,
                                        menu: ({ width, ...css }) => ({
                                            ...css,
                                            minWidth: 680,
                                        }),
                                    }}
                                />
                                {/* <Input className='mb-2' onKeyDown={handleKeyDown} onChange={_onchange} type="text" value={query} placeholder="Tìm kiếm tên/mã sản phẩm" /> */}
                            </InputGroup>
                        </Col>
                    </Row>
                </div>}
            <div className="table-responsive" style={{ overflow: 'unset' }}>
                <table className="mb-0 table-custom no-bg table table-input" >
                    <thead>
                        <tr>
                            <th className="text-center" style={{ width: 20 }}>Ảnh</th>
                            <th style={{ width: '21%' }}>Mã - Tên sản phẩm</th>
                            <th style={{ width: '14%' }}>Lô</th>
                            <th style={{ width: '13%' }}>Đơn vị</th>
                            <th style={{ width: '13%' }}>Số lượng</th>
                            <th style={{ width: '13%' }}>Giá bán</th>
                            <th style={{ width: '16%' }}>Giảm giá</th>
                            <th style={{ width: '20%' }}>Thành tiền</th>
                            {!onlyView && <th style={{ width: '4%' }}></th>}
                        </tr>
                    </thead>
                    <tbody>
                        {
                            product?.map((item: any, index: number) => (
                                <ProductItem
                                    key={`item-product-${index}`}
                                    detailIndex={index}
                                    data={item}
                                    dataParent={data}
                                    onChangeData={(dataDetail: any) =>
                                        handleProductUpdate(dataDetail, index)
                                    }
                                    productTemplate={productTemplate}
                                    type={type}
                                    onlyView={onlyView}
                                    handleRemoveData={() => handleProductRemove(index)}
                                    detail={product}
                                />
                            ))
                        }
                    </tbody>
                </table>
                <Col md={6} style={{ float: 'right' }}>
                    <div style={{ display: 'flex', justifyContent: 'space-between', width: '100%' }}>
                        <ValueTextLabel>Tổng giảm giá</ValueTextLabel>
                        <ValueTextValue className='only-view' style={{ flexDirection: 'row-reverse' }}>{PriceUtils.format(total?.discount)}</ValueTextValue>
                    </div>
                    <div style={{ display: 'flex', justifyContent: 'space-between', width: '100%' }}>
                        <ValueTextLabel>Tổng tiền hàng</ValueTextLabel>
                        <ValueTextValue className='only-view' style={{ flexDirection: 'row-reverse' }}>{PriceUtils.format(total?.total)}</ValueTextValue>
                    </div>
                    <div style={{ display: 'flex', justifyContent: 'space-between', width: '100%' }}>
                        <ValueTextLabel>Thành tiền </ValueTextLabel>
                        <ValueTextValue className='only-view' style={{ flexDirection: 'row-reverse' }}>{PriceUtils.format(total?.sub_total)}</ValueTextValue>
                    </div>
                </Col>
            </div>
        </PageBody>
    )
}

const ProductItem = (props: any) => {
    const { detailIndex, detail, onChangeData, data, dataParent, productTemplate, type, onlyView, handleRemoveData, handleAddData, handleActionModal } = props
    const [cout, setCout] = useState<any>()
    const handleChangeData = (event?: any) => {
        const { value, name } = event.target
        setCout(value);
        onChangeData({
            ...data,
            [name]: value
        })
    }

    const calTotalItem = () => {
        const total = Number(data?.price || 0) * Number(data?.quantity || 0)
        const discount = data?.discount_type === 'price' ? Number(data?.discount_value || 0) :
            total * Number(data?.discount_value || 0) / 100
        return Math.floor(
            Number(total || 0) - (Number(discount || 0) * Number(data?.quantity || 0))
        )
    }
    
    let stock_quantity = data?.product?.stock_quantity && data?.product?.stock_quantity[data?.variant_id || 'root']
        && data?.product?.stock_quantity[data?.variant_id || 'root'][dataParent?.branch_id || 'root']
        && data?.product?.stock_quantity[data?.variant_id || 'root'][dataParent?.branch_id || 'root'][data?.batch_id || 'root'] || 0
    if (data?.product?.type === 'batch' && !data?.batch_id) stock_quantity = 0

    return (
        <tr key={`item-product-${detailIndex}`}>
            <td>
                <label className="tee-file-preview" htmlFor="avatar" style={{ width: 40, height: 40, marginRight: 10 }}>
                    <img src={data?.product?.avatar || profilePic} style={{ maxWidth: 'unset', maxHeight: 'unset' }} />
                </label>
            </td>
            <td>
                {data?.product?.sku}<br />{data?.product?.name}
                {stock_quantity === 0 && (
                    <div className="invalid-feedback d-block">
                        Sản phẩm này đã hết hàng
                    </div>
                )}

                {stock_quantity > 0 && stock_quantity < cout && (
                    <div className="invalid-feedback d-block">
                        Tồn kho hiện tại {stock_quantity}
                    </div>
                )}
            </td>
            {data?.product?.type === 'batch' ?
                <td style={{ width: '13%' }}>
                    <Select
                        placeholder={(type == 'view' && !data?.batch_id) ? "---" : "Chọn lô..."}
                        className="react-select"
                        classNamePrefix="react-select"
                        isDisabled={onlyView}
                        onChange={(val: any) => {
                            onChangeData({
                                ...data,
                                batch_id: val?.value,
                            })
                        }}
                        value={data?.product?.batchs?.filter(
                            (option: any) => data?.batch_id === option.value
                        )}
                        options={data?.product?.batchs}
                        noOptionsMessage={() => 'Chưa có lô'}
                        styles={{
                            menu: ({ width, ...css }) => ({
                                ...css,
                                minWidth: 200,
                            }),
                        }}
                    ></Select>
                </td> : <td></td>
            }
            <td>

                <Select
                    placeholder={(type == 'view' && !data?.unit_id) ? "---" : "Chọn đơn vị..."}
                    className="react-select"
                    classNamePrefix="react-select"
                    isDisabled={onlyView}
                    onChange={(val: any) => {
                        onChangeData({
                            ...data,
                            unit_id: val?.value,
                        })
                    }}
                    value={data?.product?.units?.filter(
                        (option: any) => data?.unit_id === option.value
                    )}
                    options={data?.product?.units}
                    noOptionsMessage={() => 'Chưa có đơn vị'}
                    styles={{
                        ...customStyles,
                        menu: ({ width, ...css }) => ({
                            ...css,
                            minWidth: 200,
                        }),
                    }}
                ></Select>
            </td>
            <td>
                <NumberFormat
                    onChange={(e: any) => {
                        let value = TextUtils.onlyNumber(e.target.value)
                        handleChangeData({ target: { name: 'quantity', value: value } })
                    }}
                    name={'quantity'} type={'text'} className="form-control"
                    value={type === 'view' && !data?.quantity ? '---' : data?.quantity}
                    disabled={onlyView}
                    placeholder={(type == 'view' && !data?.quantity) ? "---" : "Nhập số lượng..."} thousandSeparator={true}
                />
            </td>
            <td>
                <NumberFormat
                    onChange={(e: any) => {
                        let value = TextUtils.onlyNumber(e.target.value)
                        handleChangeData({ target: { name: 'price', value: value } })
                    }}
                    name={'price'} type={'text'} className="form-control"
                    value={type === 'view' && !data?.price ? '---' : data?.price}
                    disabled={onlyView}
                    placeholder={(type == 'view' && !data?.price) ? "---" : "Nhập giá..."} thousandSeparator={true}
                />
            </td>
            <td>
                <div className='order-discount-group'>
                    <NumberFormat
                        onChange={(e: any) => {
                            let value = TextUtils.onlyNumber(e.target.value)
                            handleChangeData({ target: { name: 'discount_value', value: value } })
                        }}
                        name={'discount_value'} type={'text'} className="form-control discount_value"
                        value={type === 'view' && !data?.discount_value ? '---' : data?.discount_value}
                        disabled={onlyView}
                        placeholder={(type == 'view' && !data?.discount_value) ? "---" : "Nhập giá trị..."} thousandSeparator={true}
                    />
                    <Button style={{ opacity: 1 }} disabled={onlyView} onClick={() => handleChangeData({ target: { name: 'discount_type', value: 'price' } })} className="react-select discount_type" color={data?.discount_type === 'price' ? 'success' : 'light'}>đ</Button>
                    <Button style={{ opacity: 1 }} disabled={onlyView} onClick={() => handleChangeData({ target: { name: 'discount_type', value: 'percent' } })} className="react-select discount_type" color={data?.discount_type === 'percent' ? 'success' : 'light'}>%</Button>
                </div>
            </td>
            <td>{PriceUtils.format(calTotalItem())}</td>
            {!onlyView && <td>
                <Button onClick={handleRemoveData} className='nutri-square bg-none' color='success'><i className='uil-trash-alt'></i></Button>
            </td>}
        </tr>
    )
}

const ValueText = styled.div`
    min-height: 36px;
    display:flex;
    align-items:center;
    &.only-view {
        border-bottom: 1px solid #e2e7f1;
    }
`

const ValueTextLabel = styled.div`
    min-height: 36px;
    display:flex;
    align-items:center;
    color: #1C1D21;
    font-weight: 500;
    font-size: 14px;
    line-height: 17px;
    flex: 2;
`

const ValueTextValue = styled.div`
    min-height: 36px;
    display:flex;
    align-items:center;
    color: #1C1D21;
    font-weight: 500;
    font-size: 14px;
    line-height: 17px;
    flex: 3;
`

const customStyles = {
    menuList: (base: any) => ({
        ...base,
        maxHeight: 200,
        overflowY: "auto"
    }),
};

export default OrderAddInfo